import { Injectable, signal } from '@angular/core';
import { VestaAnnotationUpdateLike } from '../models/vesta-annotation.model';
import { VirginStructureLike } from '../models/vesta-virgin-structure.model';
import {VestaCommandType} from '../types/vesta-command.types';
import {VestaCommand} from '../models/vesta-command.model';
import {VestaUiEvent} from '../models/vesta-ui.model';
import {VestaScreenshotFn} from "@app/vesta/models/vesta-screenshot.model";

@Injectable({ providedIn: 'root' })
export class VestaStateService {
  private readonly _commandQueue = signal<VestaCommand[]>([]);
  private readonly _uiEvents = signal<VestaUiEvent[]>([]);
  readonly commandQueue = this._commandQueue.asReadonly();
  readonly snapshot = signal<any | null>(null);
  readonly meshClick = signal<any | null>(null);
  readonly initialized = signal(false);
  readonly ready = signal(false);
  readonly uiEvents = this._uiEvents.asReadonly();
  private _screenshotFn = signal<VestaScreenshotFn | null>(null);
  readonly screenshotFn = this._screenshotFn.asReadonly();

  setScreenshotFn(fn: VestaScreenshotFn | null): void {
    this._screenshotFn.set(fn);
  }

  clearScreenshotFn(): void {
    this._screenshotFn.set(null);
  }

  applyVirginStructure(payload: VirginStructureLike[], oldMutuallySelected?: string[]): void {
    this.push({type: VestaCommandType.VirginStructure, payload, oldMutuallySelected});
  }

  applyViewUpdate(payload: any): void {
    this.push({type: VestaCommandType.ViewUpdate, payload});
  }

  applyAnnotationUpdate(payload: VestaAnnotationUpdateLike): void {
    this.push({type: VestaCommandType.AnnotationUpdate, payload});
  }

  clearCommands(): void {
    this._commandQueue.set([]);
  }

  pushUiEvent(event: VestaUiEvent): void {
    this._uiEvents.update(list => [...list, event]);
  }

  clearUiEvents(): void {
    this._uiEvents.set([]);
  }

  private push(cmd: VestaCommand): void {
    this._commandQueue.update(queue => [...queue, cmd]);
  }
}
